/* eslint-disable */
import AOS from 'aos';

const ContentLoadingAnimations = {
  init: function () {
    const self = this;
    const homePreloader = document.querySelector('[data-home-preloader-js]');
    if (homePreloader) {
      window.scrollTo(0, 0);
      this.homePreloaderLogoPosition(homePreloader);
      this.insertSVGIntoHomePreloader(homePreloader);
      setTimeout(function () {
        window.scrollTo(0, 0);
        self.hidePreloader();
        self.showHeader();
        AOS.init();
      }, 1900);
    } else {
      this.hidePreloader();
      this.showHeader();
      AOS.init();
    }
  },

  insertSVGIntoHomePreloader: function (homePreloader) {
    const preloaderLogoWrap = homePreloader.querySelector('[data-logo-wrap-js]');
    let svgCloneWrap = homePreloader.querySelector('[data-logo-clonne-js]');
    if (!preloaderLogoWrap || !svgCloneWrap) return;

    preloaderLogoWrap.innerHTML = svgCloneWrap.innerHTML;
  },

  homePreloaderLogoPosition: function (homePreloader) {
    const heroSection = document.querySelector('[data-hero-home-block-js]');
    if (!heroSection) return;

    const hero3dWrap = heroSection.querySelector('[data-deco-wrap-js]');
    const preloaderLogoWrap = homePreloader.querySelector('[data-logo-wrap-js]');
    if (!preloaderLogoWrap || !hero3dWrap) return;

    const hero3dWrapStyles = window.getComputedStyle(hero3dWrap);
    const hero3dWrapCoordinates = hero3dWrap.getBoundingClientRect();

    preloaderLogoWrap.style.width = 'calc(' + hero3dWrapStyles.width + ' + ' + '0.3%)';
    preloaderLogoWrap.style.height = 'calc(' + hero3dWrapStyles.height + ' + ' + '1.8%)';
    preloaderLogoWrap.style.top = 'calc(' + hero3dWrapCoordinates.top  + 'px' + ' - ' + '0.4%)';
    preloaderLogoWrap.style.left = 'calc(' + hero3dWrapCoordinates.left + 'px' + ' - ' + '0.3%)';
  },

  hidePreloader: function () {
    const preloader = document.querySelector(".preloader");
    if (preloader) {
      preloader.classList.remove("is-active");
    }
  },

  showHeader: function () {
    const header = document.querySelector('[data-header-js]');

    header.classList.add('is-active');
  },
}

export default ContentLoadingAnimations;
